export default "__VITE_ASSET__DXCvbD_6__"